const MetaTrader4MobileContentFour = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <div className="content-left">
                <h2>All the Markets, in the Palm of Your Hand</h2>

                <p>
                  Diversify your portfolio and access a wide range of global
                  instruments directly through MT4 Mobile.
                </p>
              </div>
              <img
                src={process.env.PUBLIC_URL + "/images/platforms/meta_trader_4_mobile/meta_trader_4_mobile_3.jpg"}
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h3>Forex</h3>
              <p>
                Trade over 60 currency pairs with tight spreads and
                lightning-fast execution speeds.
                {/* Conversely, rate cuts can weaken a
                currency as investors seek higher yields elsewhere. Traders
                closely follow central bank announcements and policy statements
                to anticipate shifts in monetary policy. */}
              </p>
              <hr className="black-line" />
              <h3> Commodities</h3>
              <p>
                Speculate on energy, metal, and agricultural assets with
                real-time market data and price tracking.
                {/* Stable inflation and strong
                performance usually strengthen a currency, while economic
                slowdown or uncertainty can cause depreciation. Traders monitor
                key indicators like CPI, PMI, and retail sales to identify
                potential trends in currency valuation. */}
              </p>
              <hr className="black-line" />
              <h3>Indices</h3>
              <p>
                Access leading global indices with precise control over
                leveraged trades and portfolio exposure.
                {/* In contrast, geopolitical
                tensions or unexpected global events can increase volatility as
                traders move toward safe-haven assets like the USD, CHF, or JPY. */}
              </p>
              <hr className="black-line" />
              <h3>Cryptocurrencies</h3>
              <p>
                Stay ahead in the digital asset market with secure and
                responsive crypto trading built into your MT4 app.
                {/* Large institutional players and algorithmic trading
                systems can amplify these effects, making sentiment analysis a
                valuable tool for modern forex traders. */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTrader4MobileContentFour;
